import "./WeeklyOverview.scss";

export default function WeeklyOverview() {
  return (
    <section className="sales-layout__page weekly-overview">
      <h1>Wochenübersicht</h1>
      <p>Hier werden zukünftig die Wochenübersichten angezeigt.</p>
    </section>
  );
}
